export default "./dist/stdassets/images/icons/toggle-expand.png";